import { useScrollToEnd } from '@repo/ui/hooks'
import { ReactNode, useEffect, useMemo, useRef } from 'react'

import { AssistantFeedItem } from '@/store/assistant'
import { useStoreState } from '@/store/hooks'

import { FeedItemRenderer } from './FeedItemRenderer'

export const FeedSection = ({ isThinking }: { isThinking: boolean }) => {
  return (
    <FeedSectionWrapper isThinking={isThinking}>
      {({ feed, item, isThinking, index }) => (
        <FeedItemRenderer
          key={item.id}
          feed={feed}
          index={index}
          isThinking={isThinking}
          item={item}
        />
      )}
    </FeedSectionWrapper>
  )
}

const FeedSectionWrapper = ({
  isThinking,
  children,
}: {
  isThinking: boolean
  children: (props: {
    feed: AssistantFeedItem[]
    index: number
    isThinking: boolean
    item: AssistantFeedItem
  }) => ReactNode
}) => {
  const assistantBottomRef = useRef<HTMLDivElement>(null)
  const scrollToFeedEnd = useScrollToEnd(assistantBottomRef, 'smooth')

  const feed = useStoreState((state) => state.assistant.feed)
  const countTasks = useMemo(
    () =>
      feed
        .filter((item) => item.type === 'tasks')
        .map((item) => item.tasks)
        .flat().length,
    [feed],
  )

  useEffect(() => {
    // Delay slightly to allow DOM update before scrolling
    const timer = setTimeout(() => scrollToFeedEnd(), 100)
    return () => clearTimeout(timer)
  }, [feed.length, countTasks, scrollToFeedEnd])

  return (
    <div className="mx-4 mb-4 flex flex-col gap-4">
      {feed.map((item, index) => children({ feed, index, isThinking, item }))}
      <div className="h-10" id="assistant-end" ref={assistantBottomRef} />
    </div>
  )
}
